export default (get) => {
  return Object.keys(get().compatibilitySegments);
};
